<template>
  <BasicModalWindow
    ref="modal_element"
    class="small-window folders-actions"
    :title="modal_title"
    :gtm="{
      module : 'folders',
      feature: 'folders_create_modal',
      block  : `modal_header`,
      action : 'cancel'
    }"
  >
      <template #body>
        <div class="form">
            <fieldset>
                <div class="control-group">
                    <div class="control">
                        <label for="new_folder_name">{{Language.say('folders.folders_name')}}</label>
                        <input id="new_folder_name" @keyup.enter="onAddFolder()" type="text" v-focus="true" v-model="new_folder_name">
                    </div>
                </div>
          </fieldset>

        </div>
      </template>
      <template #footer>
          <ActionButton
              @click="onAddFolder()"
              icon='fas fa-folder-open'
              class='main-action push-right'
              :loading="folders_controller.saving_state.saving['folders_create']"
              :disabled="!new_folder_name"
              :text="(!parent_folder) ? 'folders.actions.add_folder' : 'folders.actions.add_subfolder'"
              :gtm="{
                module : 'folders',
                feature: 'folders_create_modal',
                block  : `modal_footer`,
                action : 'submit'
              }"
          />
      </template>
  </BasicModalWindow>
</template>

<script setup>
  import {defineProps, ref} from 'vue';
  import {onBeforeMount }   from 'vue';
  import BasicModalWindow   from '@/vue/Layouts/Modals/BasicModalWindow.vue';
  import ActionButton       from '@/vue/Elements/Buttons/ActionButton.vue'
  import FoldersController  from '@/js/Mailboxes/FoldersController';
  import Language           from '@/js/Shared/Language/Language.js';


  const props   = defineProps({
    parent_folder : {
      default : null,
    },
  })

  const folders_controller = FoldersController;
  const modal_element      = ref();
  const new_folder_name    = ref();
  const modal_title        = ref();

  onBeforeMount(() => {
    setModalTitle(
      (!props.parent_folder)
        ? 'folders.actions.add_folder'
        : Language.say('folders.actions.add_folder_in', [props.parent_folder.name]),
    );
  })

  const onAddFolder = async () => {
    let success  = await folders_controller.create(
      new_folder_name.value,
      props.parent_folder,
    );

    if (success) {
      closeModal();
    }
  }

  const closeModal = () => {
    modal_element.value.close();
  }

  const setModalTitle = (title) => {
    modal_title.value = title;
  }
</script>
